@if (filing) {
  <div class="card mb-3 bg-light-subtle">
    <div class="row g-0">
      <div class="col-md-3 d-none d-md-flex justify-content-center">
        <div class="country-filing-card__icon row align-content-center" [ngbTooltip]="jurisdictionCode" placement="end">
          <i class="mdi mdi-earth" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card-body">
          <h3 class="card-title">
            {{ label }}
            @if (amount) {
              <span class="badge bg-primary-subtle text-primary">
                <app-amount class="fw-semibold" [amount]="amount"></app-amount>
              </span>
            }
          </h3>
          <p class="m-0">
            <small class="text-muted">
              <i aria-hidden="true" class="mdi mdi-map-marker"></i>
              Jurisdiction:
            </small>
            <small>{{ jurisdictionCode }}</small>
          </p>
          @if (filing.frequency) {
            <p class="m-0">
              <small class="text-muted">
                <i aria-hidden="true" class="mdi mdi-calendar-range"></i>
                Filing Frequency:
              </small>
              <small>{{ filing.frequency | frequencyTransform }}</small>
            </p>
          }
          <p class="m-0">
            <small class="text-muted">
              <i aria-hidden="true" class="mdi mdi-calendar-plus"></i>
              Next Filing:
            </small>
            <small>{{ filing.next_run_date ? (filing.next_run_date | date:'MMM dd YYYY') : 'None scheduled' }}</small>
          </p>
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-end flex-column">
        <span class="m-3 badge border border-2 user-select-none py-0 text-{{ type }} text-bg-light-{{ type }} border-{{ type }}-subtle">
          {{ filing.status | lowercase | snakeToString }}
        </span>

        @if (filing.status === autoFilingStatuses.PENDING_PAYMENT) {
          <button (click)="makePayment.emit(filing)"
                  class="mt-auto m-3 btn btn-sm btn-outline-primary align-text-bottom"
                  data-test-id="country-filing-payment-button"
                  type="button">
            Make Payment
          </button>
        }
      </div>
    </div>
  </div>
}
